import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';

const StyledContentHeader = ({ text, level, blockKey, getRefs }) => {
	const parsedText = parse(sanitize(text));
	let header = null;

	switch (level) {
		case 2:
			header = (
				<h2 id={blockKey} ref={getRefs ? getRefs(blockKey) : null}>
					{parsedText}
				</h2>
			);
			break;

		default:
			header = null;
	}

	return header;
};

StyledContentHeader.propTypes = {
	text: PropTypes.string.isRequired,
	level: PropTypes.number.isRequired,
	blockKey: PropTypes.string,
	getRefs: PropTypes.func
};

export default StyledContentHeader;
